import React, { PropTypes } from 'react';

const logoutStyle = {
    boxShadow: '0 0 6px rgba(0,0,0,0.2)'
};

const Logout = ({ handleLogout, message, buttonLabel }) => (
    <div className="playback__logout" style={logoutStyle}>
        <h2>{message}</h2>
        <a className="button med stand-alone" onClick={handleLogout}>{buttonLabel}</a>
    </div>
);

Logout.propTypes = {
    handleLogout: PropTypes.func,
    message: PropTypes.string,
    buttonLabel: PropTypes.string
};

export default Logout;



// WEBPACK FOOTER //
// ./app/webapp/branding/Logout.js